import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlaskLine = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em ",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M8.99993 4H8C7.44771 4 7 3.55228 7 3C7 2.44772 7.44771 2 8 2H16C16.5523 2 17 2.44772 17 3C17 3.55228 16.5523 4 16 4H14.9999V9.63128L20.2265 17.3123C21.5817 19.3039 20.1552 22 17.7462 22H6.25366C3.84467 22 2.41818 19.304 3.77339 17.3123L8.99993 9.63128V4ZM12.9999 4H10.9999V9.63128C10.9999 10.0326 10.8792 10.4246 10.6534 10.7564L5.4269 18.4374C4.97516 19.1013 5.45066 20 6.25366 20H17.7462C18.5492 20 19.0247 19.1013 18.573 18.4374L13.3464 10.7564C13.1207 10.4246 12.9999 10.0326 12.9999 9.63128V4Z"
	})
});
export default SvgFlaskLine;
